import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-typography-4',
  templateUrl: './4.component.html',
  styleUrls: ['./4.component.scss'],
})
export class VbTypography4Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
